<!--begin::Main-->
<ngx-spinner class="custom-spinner" bdColor="rgba(255,255,255,1)" size="medium" color="#fff" type="ball-atom"
    [fullScreen]="true">
    <span class="loader">
        <img width="150px" src="/assets/media/logos/logo-wegestu-color.png" alt="">
    </span>
</ngx-spinner>
<div class="app-main flex-column flex-row-fluid" id="kt_app_main">
    <!--begin::Content wrapper-->
    <div class="d-flex flex-column flex-column-fluid">

        <!--begin::Toolbar-->
        <div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
            <!--begin::Toolbar container-->
            <div id="kt_app_toolbar_container" class="app-container container-fluid d-flex flex-stack">
                <!--begin::Page title-->
                <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
                    <!--begin::Title-->
                    <div class="d-flex align-items-center">
                        <h1 class="page-heading mt-0 mb-0"> <svg width="41" height="44" viewBox="0 0 41 44" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <g filter="url(#filter0_d_615_2549)">
                                    <path
                                        d="M15.1976 30.5794C16.2337 29.2326 17.8276 28.4404 19.5013 28.4404H25.7973C26.7537 28.4404 27.6303 28.0443 28.2679 27.4105L36.0782 19.3298C36.3173 19.0922 36.3173 18.6168 36.0782 18.3792C35.8391 18.1415 35.4406 18.0623 35.2016 18.2207L27.8694 22.5779C27.6303 23.7663 26.5943 24.7169 25.3191 24.7169H17.987C17.5885 24.7169 17.19 24.4 17.19 23.9247C17.19 23.5286 17.5885 23.1325 17.987 23.1325H25.3191C25.877 23.1325 26.3552 22.6572 26.3552 22.1026C26.3552 21.5481 25.877 21.0727 25.3191 21.0727H14.1616C12.5676 21.0727 11.0534 21.7857 10.097 22.9741L7.30762 26.3014L14.4803 31.6885L15.1976 30.5794Z"
                                        fill="#265D91" />
                                    <path
                                        d="M14.8784 33.9066L14.1611 33.352L6.27108 27.4104L4.75684 29.3117L13.3641 35.8079L14.8784 33.9066Z"
                                        fill="#265D91" />
                                    <path
                                        d="M9.93705 17.2701H30.8177C31.4552 17.2701 31.9334 16.7948 31.9334 16.161V10.1401C28.108 11.4869 24.2028 12.1999 20.3773 12.1999C16.5519 12.1999 12.6467 11.4869 8.82129 10.1401V16.161C8.82129 16.7948 9.29947 17.2701 9.93705 17.2701Z"
                                        fill="#265D91" />
                                    <path
                                        d="M31.9334 8.15949V4.59451C31.9334 3.96073 31.4552 3.4854 30.8177 3.4854H25.7967V1.10874C25.7967 0.633412 25.3983 0.158081 24.8404 0.158081H15.9143C15.4361 0.158081 14.958 0.55419 14.958 1.10874V3.4854H9.93705C9.29947 3.4854 8.82129 3.96073 8.82129 4.59451V8.15949C16.4722 11.0115 24.2825 11.0115 31.9334 8.15949ZM16.791 1.98018H23.884V3.40618H16.791V1.98018ZM19.1819 6.97116C19.1819 6.25817 19.7398 5.62439 20.3773 5.62439C21.0149 5.62439 21.5728 6.17894 21.5728 6.97116C21.5728 7.68416 21.0149 8.31793 20.3773 8.31793C19.7398 8.31793 19.1819 7.68416 19.1819 6.97116Z"
                                        fill="#265D91" />
                                </g>
                                <defs>
                                    <filter id="filter0_d_615_2549" x="0.756836" y="0.158081" width="39.501"
                                        height="43.6498" filterUnits="userSpaceOnUse"
                                        color-interpolation-filters="sRGB">
                                        <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                        <feColorMatrix in="SourceAlpha" type="matrix"
                                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                        <feOffset dy="4" />
                                        <feGaussianBlur stdDeviation="2" />
                                        <feComposite in2="hardAlpha" operator="out" />
                                        <feColorMatrix type="matrix"
                                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                                        <feBlend mode="normal" in2="BackgroundImageFix"
                                            result="effect1_dropShadow_615_2549" />
                                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_615_2549"
                                            result="shape" />
                                    </filter>
                                </defs>
                            </svg>

                            Nos offres d’emploi
                        </h1>
                        <!--begin::Menu-->
                    </div>
                    <!--end::Title-->
                    <!--begin::Breadcrumb-->
                    <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                        <!--begin::Item-->
                        <li class="breadcrumb-item text-muted">
                            <a routerLink="/accueil" class="text-muted ">Accueil</a>
                          </li>
                        <!--end::Item-->
                        <!--begin::Item-->
                        <li class="breadcrumb-item">
                            <span class="bg-gray-400 w-5px h-2px"></span>
                        </li>
                        <!--end::Item-->
                        <!--begin::Item-->
                        <li class="breadcrumb-item text-muted"> <a class="text-muted " routerLink="/offres-emploi/liste-offres-emploi">Nos offres d’emploi</a></li>
                        <li class="breadcrumb-item">
                            <span class="bg-gray-400 w-5px h-2px"></span>
                        </li>
                        <!--end::Item-->
                        <!--begin::Item-->
                        <li class="breadcrumb-item text-muted">Modifier une offre d’emploi</li>
                        <!--end::Item-->
                    </ul>
                    <!--end::Breadcrumb-->
                </div>
                <!--end::Page title-->
                <!--begin::Actions-->

                <!--end::Actions-->
            </div>
            <!--end::Toolbar container-->
        </div>
        <!--end::Toolbar-->

        <!--begin::Content-->

        <div id="kt_app_content" class="app-content flex-column-fluid mb-4">
            <!--begin::Content container-->
            <div id="kt_app_content_container" class="app-container container-fluid">
                <!--begin::Card-->
                <div class=" card content">

                    <!--begin::Card header-->
                    <div class="container-content">
                        <div class="d-flex flex-wrap header-grid align-items-center">
                            <div class="section_title mx-15 my-5 mb-0">
                                <h1 class="section-heading">Modifier une offre d’emploi</h1>
                            </div>
                        </div>
                        <form [formGroup]="updateform">
                    <div class="modal-body mx-5 my-5 mt-0">
                        <!--begin::Heading-->
                        <!--end::Heading-->

                        <!--begin::Users-->
                        <div class="container">
                            <!--begin::User-->
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-sm-6 mb-5 tools">
                                        <label for="poste" class="required"> Poste</label>
                                        <input type="text" formControlName="name" id="poste" class="form-control mb-3"
                                            placeholder="Poste">
                                            <div *ngIf="
                                                updateform.get('name')?.hasError('required') &&
                                                updateform.get('name')?.touched
                                              " class="text-danger">
                                              Le champ "Poste" est obligatoire .
                                            </div>
                                    </div>
                                    <div class="col-sm-6 mb-5 tools">
                                        <label for="poste" class="required"> Années d'éxperience</label>
                                        <input type="number" formControlName="years_of_experience" id="annee" min="0"
                                            oninput="validity.valid||(value='0');" placeholder="Années d'experience"
                                            class="form-control mb-3">
                                              <div *ngIf="
                                                updateform.get('years_of_experience')?.hasError('required') &&
                                                updateform.get('years_of_experience')?.touched
                                              " class="text-danger">
                                              Le champ "Années d'éxperience" est obligatoire .
                                            </div>
                                    </div>
                                    <div class="col-sm-6 mb-5 tools ">
                                        <label for="poste"> Type de poste</label>
                                        <!-- <select data-control="select2" placeholder="type de poste"
                                    data-hide-search="true" class="form-select mb-3" formControlName="post_type">

                                    <option value="1">hybride</option>
                                    <option value="2">à distance</option>
                                    <option value="3">télétravail</option>

                                </select> -->
                                        <ng-select [items]="poste" bindLabel="name" bindValue="id"
                                            [notFoundText]="'Aucun élément trouvé'" formControlName="post_type"
                                            [placeholder]="'Type de poste'" autoComplete>
                                        </ng-select>
                                        
                                    </div>
                                    <div class="col-sm-6 mb-5 tools ">
                                        <label for="poste"> Type de contrat</label>
                                     
                                        <ng-select placeholder="Type de contrat" data-hide-search="true" name="format"
                                            formControlName="contract_type" class="form-select mb-3" [multiple]="true"
                                            [notFoundText]="'Aucun élément trouvé'">
                                            <ng-option *ngFor="let contractType of contrat" [value]="contractType.id">{{
                                                contractType.name }}</ng-option>
                                        </ng-select>
                                    </div>
                                    <div class="col-sm-6 mb-5 tools ">
                                        <label for="poste"> Salaire</label>
                                        <input type="number" formControlName="salary" id="Salaire"
                                            class="form-control mb-3" min="0" oninput="validity.valid||(value='0');"
                                            placeholder="Salaire">

                                    </div>
                                    <div class="col-sm-6 mb-5 tools ">
                                        <label for="poste"> TJM</label>
                                        <input type="number" formControlName="tjm" id="TJM" class="form-control mb-3"
                                            min="0" oninput="validity.valid||(value='0');" placeholder="TJM">

                                    </div>
                                    <div class="col-sm-6 mb-5 tools ">
                                        <label for="poste" class="required"> Pays destinataire</label>
                                        <ng-select (change)="onCountryChange($event);" [items]="paysList"
                                            [multiple]="true" [notFoundText]="'Aucun élément trouvé'"
                                            id="pays_destinataire" bindLabel="name" bindValue="name"
                                            [placeholder]="'Pays'" autoComplete formControlName="country"
                                            [notFoundText]="'Aucun élément trouvé'" autoComplete>
                                            <ng-template ng-optgroup-tmp let-item="item">
                                                {{ item.name || "Unnamed group" }}
                                            </ng-template>
                                        </ng-select>
                                              <div *ngIf="
                                                updateform.get('country')?.hasError('required') &&
                                                updateform.get('country')?.touched
                                              " class="text-danger">
                                              Le champ "Pays destinataire" est obligatoire .
                                            </div>
                                    </div>
                                    <div class="col-sm-6 mb-5 tools ">
                                        <label for="poste"> Ville </label>
                                   
                                        <ng-select [items]="stateList"  bindLabel="name"
                                             (change)="onMobilityChange('add')" formControlName="city" [ngClass]="{'disable-select':!stateList?.length}" [attr.disabled]="!stateList?.length ? true : null" [multiple]="true"
                                             bindValue="name" class="mb-3" [placeholder]="'Ville'" autoComplete
                                             [notFoundText]="'Aucun élément trouvé'">
                                         </ng-select>

                                    </div>

                                    <div class="col-sm-6 mb-5 ">
                                        <div class="etranger">
                                            <div class="form-check form-check-custom form-check-solid">
                                                <input class="form-check-input" formControlName="profile_abroad"
                                                    type="checkbox" value="" id="flexCheckChecked" checked />
                                                <label class="form-check-label" for="flexCheckChecked">
                                                    Possibilité profil à l'étranger
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-6 mb-5" *ngIf="showPasseportTalent">
                                        <div class="etranger">
                                            <div class="form-check form-check-custom form-check-solid">
                                                <input class="form-check-input" type="checkbox" value=""
                                                    formControlName="passeport_talent" id="flexCheckChecked1" checked />
                                                <label class="form-check-label" for="flexCheckChecked1">
                                                    Passeport talent
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-12 col-12 mb-5 tools">
                                           <div class="mb-5">
                                             <label for="nom" class="required">Compétences</label>
                                            <ng-select [items]="skillsList" bindLabel="name_FR" bindValue="id" [notFoundText]="'Aucun élément trouvé'"
                                                formControlName="skills" [multiple]="true" id="skillsList"
                                                [placeholder]="'Compétences *'" autoComplete>
                                            </ng-select>
                                <ng-container *ngFor="let categorie of skills ; let i = index">
                                        <div *ngFor="let sub of categorie.subcategories" >{{
                                                sub.name }}</div>

                                </ng-container>
                                            
                                            <span class="requirements mb-3">
                                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                  <g clip-path="url(#clip0_379_198)">
                                                    <path
                                                      d="M8 16C9.58225 16 11.129 15.5308 12.4446 14.6518C13.7602 13.7727 14.7855 12.5233 15.391 11.0615C15.9965 9.59966 16.155 7.99113 15.8463 6.43928C15.5376 4.88743 14.7757 3.46197 13.6569 2.34315C12.538 1.22433 11.1126 0.462403 9.56072 0.153721C8.00887 -0.15496 6.40034 0.00346629 4.93853 0.608967C3.47672 1.21447 2.22729 2.23985 1.34824 3.55544C0.469192 4.87104 0 6.41775 0 8C0.00229405 10.121 0.845886 12.1545 2.34568 13.6543C3.84547 15.1541 5.87897 15.9977 8 16ZM8 3.33334C8.19778 3.33334 8.39112 3.39199 8.55557 3.50187C8.72002 3.61175 8.84819 3.76793 8.92388 3.95065C8.99957 4.13338 9.01937 4.33445 8.98079 4.52843C8.9422 4.72241 8.84696 4.90059 8.70711 5.04044C8.56726 5.1803 8.38907 5.27554 8.19509 5.31412C8.00111 5.35271 7.80004 5.3329 7.61732 5.25722C7.43459 5.18153 7.27841 5.05336 7.16853 4.88891C7.05865 4.72446 7 4.53112 7 4.33334C7 4.06812 7.10536 3.81377 7.29289 3.62623C7.48043 3.43869 7.73478 3.33334 8 3.33334ZM7.33333 6.66667H8C8.35362 6.66667 8.69276 6.80715 8.94281 7.0572C9.19286 7.30724 9.33333 7.64638 9.33333 8V12C9.33333 12.1768 9.2631 12.3464 9.13807 12.4714C9.01305 12.5964 8.84348 12.6667 8.66667 12.6667C8.48986 12.6667 8.32029 12.5964 8.19526 12.4714C8.07024 12.3464 8 12.1768 8 12V8H7.33333C7.15652 8 6.98695 7.92977 6.86193 7.80474C6.73691 7.67972 6.66667 7.51015 6.66667 7.33334C6.66667 7.15653 6.73691 6.98696 6.86193 6.86193C6.98695 6.73691 7.15652 6.66667 7.33333 6.66667Z"
                                                      fill="#2b5d8f" />
                                                  </g>
                                                  <defs>
                                                    <clipPath id="clip0_379_198">
                                                      <rect width="16" height="16" fill="white" />
                                                    </clipPath>
                                                  </defs>
                                                </svg>
                                                &nbsp;<span style="padding-top: 3px;font-size:12px">Si vous n'ajoutez pas de compétence, vous ne pourrez pas créer de test par la suite.</span> 
                                            </span><br />
                                            <!-- <app-feild-error [control]="formjoboffer.get('skills')"
                                                [controlName]="'skills'"></app-feild-error> -->
                                                <div *ngIf="
                                                updateform.get('skills')?.hasError('required') &&
                                                updateform.get('skills')?.touched
                                              " class="text-danger">
                                              Le champ "Compétences" est obligatoire .
                                            </div>
                                        </div>
                                    </div>
                                     <div class="col-sm-6 autres mb-5">
                                             <label for="nom">Autres compétences</label>
                                            <mat-chip-grid #chipGrid aria-label="Enter skill">
                                              <mat-chip-row *ngFor="let skill of addSkills" (removed)="remove(skill)"
                                                [editable]="true" (edited)="edit(skill, $event)" >
                                                {{ skill.name }}
                                                <button matChipRemove [attr.aria-label]="'remove ' + skill.name">
                                                  <mat-icon>x</mat-icon>
                                                </button>
                                              </mat-chip-row>  
                                              <input  placeholder="Autres compétences (séparées par  , )" (blur)="isFormatCompetenceAdmin=false"
                                                [matChipInputFor]="chipGrid" [matChipInputSeparatorKeyCodes]="
                                                  separatorKeysCodes
                                                " [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="add($event)" />
                                            </mat-chip-grid>
                                        </div>
                                    <div class="col-sm-6 mb-5 tools">
                                        <label for="poste"> Disponibilité </label>
                                        <ng-select [items]="disponibilite" formControlName="availability"
                                            [notFoundText]="'Aucun élément trouvé'" bindLabel="name" bindValue="id"
                                            [placeholder]="'Disponibilité'" autoComplete>
                                        </ng-select>
                                    </div>
                                    
                                    <div class="col-sm-12 mb-5 tools">
                                       <label for="poste" class="required"> Description</label>
                                    <div class="desc tools mb-5">
                                        <quill-editor [placeholder]="'Description'" formControlName="description"
                                            [modules]="{ toolbar: toolbarOptions }"  (onContentChanged)="onContentChange($event)"

                                            style="width: 100%; height: 300px;"></quill-editor>
                                              <div *ngIf="
                                                updateform.get('description')?.hasError('required') &&
                                                updateform.get('description')?.touched
                                              " class="text-danger">
                                              Le champ "Description" est obligatoire .
                                            </div>
                                    </div>
                                </div>
                               
                                </div>
                                <div class="modal-footer text-center">
                            <div class="actions">
                                <a class="annuler cursor-pointer" routerLink="/offres-emploi/liste-offres-emploi">Annuler</a>
                                <button [disabled]="this.updateform.invalid" (click)="updatejoboffer()"
                                    class="confirmer">Confirmer</button>
                            </div>
                        </div>
                            </div>

                            <!--end::User-->
                        </div>

                        
                        <!--end::Users-->
                    </div>
                </form>
                    </div>
                    <!--end::Card header-->
                    <!--begin::Card body-->

                    <!--end::Card body-->
                </div>
                <!--end::Card-->
                <!--begin::Modals-->
                <!--begin::Modal - Customers - Add-->

                <!--end::Modal - Customers - Add-->
                <!--begin::Modal - Adjust Balance-->

                <!--end::Modal - New Card-->
                <!--end::Modals-->
            </div>
            <!--end::Content container-->
        </div>
        <!--end::Content-->
    </div>
    <!--end::Content wrapper-->
    <!--end:::Main-->
</div>
<ng-template #publier>
    <!-- <div class="modal fade" tabindex="-1" id="publier"> -->
        <!-- <div class="modal-dialog modal-dialog-centered"> -->
            <div class="modal-content" tabindex="-1" id="publier">  
                <div class="modal-header">
                    <h3 class="modal-title">Assigner un test pour cette offre d'emploi</h3>

                    <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" (click)="closeModalAndRedirect()">
                        <i class="ki-duotone ki-cross fs-1"><span class="path1"></span><span class="path2"></span></i>
                    </div>
                </div>
                <div class="modal-body">
                    <div class="message mb-5">
                        <span>Après publier cette offre d'emploi, Voulez-vous ajouter un test?</span>
                    </div>
                    <div class="choice">
                        <div class="form-check form-check-custom form-check-solid">
                            <input 
                                class="form-check-input" 
                                type="checkbox" 
                                [(ngModel)]="addScale"
                                (change)="onAddScaleChange()" 
                                id="flexCheckDefault1"
                                [disabled]="addTestChecked ||addScaleAndTest || !subscriptionCanAccess('Barème')" 
                            />
                            <label class="form-check-label" for="flexCheckDefault1" 
                            [ngbTooltip]="!subscriptionCanAccess('Barème') ? 'Votre abonnement n’inclut pas cette fonctionnalité.' : null"
                            >
                                <span>Ajouter un barème</span>
                            </label>
                        </div>
                        <div class="form-check form-check-custom form-check-solid">
                            <input 
                                class="form-check-input" 
                                type="checkbox" 
                                [(ngModel)]="addTestChecked"
                                (change)="onAddTestChange()" 
                                id="flexCheckDefault2"
                                [disabled]="addScale || addComp || addScaleAndTest"
                            />
                            <label class="form-check-label" for="flexCheckDefault2">
                                <span>Ajouter un test de compétence</span>
                            </label>
                        </div>
                        <div class="form-check form-check-custom form-check-solid"
                        >
                            <input 
                                class="form-check-input" 
                                type="checkbox" 
                                [(ngModel)]="addScaleAndTest"
                                (change)="onAddTestChange()" 
                                id="flexCheckDefault3"
                                [disabled]="addComp || addTestChecked|| addScale || !subscriptionCanAccess('Barème')"
                            />
                            <label class="form-check-label" for="flexCheckDefault3"
                            [ngbTooltip]="!subscriptionCanAccess('Barème') ? 'Votre abonnement n’inclut pas cette fonctionnalité.' : null"
                            >
                                <span>Ajouter un barème et un test de compétence </span>
                            </label>
                        </div>
                        
                    </div>
                    <div class="tests" *ngIf="addTestChecked">
                        <div class="form-check form-check-custom form-check-solid">
                          <input 
                            class="form-check-input" 
                            type="radio" 
                            [(ngModel)]="selectedTest" 
                            id="flexRadioDefault1" 
                            [value]="'wegestu'" 
                            (change)="onTestChange()"
                            name="testOptions"
                          />
                          <label class="form-check-label" for="flexRadioDefault1">
                            Test WeGestU
                          </label>
                        </div>
                        <div class="form-check form-check-custom form-check-solid">
                          <input 
                            class="form-check-input" 
                            type="radio" 
                            [(ngModel)]="selectedTest" 
                            id="flexRadioDefault2" 
                            [value]="'test'"
                            (change)="onTestChange()"
                            name="testOptions"
                          />
                          <label class="form-check-label" for="flexRadioDefault2">
                            Test Entreprise
                          </label>
                        </div>
                      </div>
                      
                </div>
                <div class="modal-footer">
                
                        <button type="button"(click)="closeModalAndRedirect()" class="btn btn-light">Annuler</button>
                   <button type="button"
                            [disabled]="!addTest && !addTestWegestU && !addTestChecked && !addScale && !addScaleAndTest"
                            class="btn btn-primary" (click)="onConfirm(jobId)">Confirmer</button>
                </div>
            </div>
        <!-- </div> -->
    <!-- </div> -->
</ng-template>
